define((require) => {
    "use strict";

    const Matrix    = require("shared/vendor/Matrix");
    const $         = require("jquery");

    /** @typedef {{x: number, y: number}} Coordinate */

    class SnapUtils {
        /**
         * @static
         * Create an Array of 4 coordinates from a DOMElement
         * in this order top-left,top-right,bottom-left,bottom-right
         * @return {Array<Coordinate>}
         */
        static getRoundedCornerCoordinatesFromDom(el) {
            const $el         = $(el);
            const matrix      = Matrix.createFromDom($el[0]);
            const width       = $el.outerWidth();
            const height      = $el.outerHeight();
            const nonRoundedCoordinates  = [
                matrix.getGlobalCoordByLocalCoord(0, 0),            // top left
                matrix.getGlobalCoordByLocalCoord(width, 0),        // top right
                matrix.getGlobalCoordByLocalCoord(0, height),       // bottom left
                matrix.getGlobalCoordByLocalCoord(width, height)    // bottom right
            ];
            return nonRoundedCoordinates.map(SnapUtils.roundCoordinate);
        }

        /**
         * @static
         * Round the values of an object
         * @param {Coordinate} coord
         * @return {Coordinate}
         */
        static roundCoordinate(coord) {
            return {
                x: Math.round(coord.x),
                y: Math.round(coord.y)
            };
        }
    }

    return SnapUtils;
});



// WEBPACK FOOTER //
// ./src/editor/util/SnapUtils.js